import { CastToNumber, FromSchema } from '@40seas/entities/common';
import { Address, AddressSchema, Identification, IdentificationSchema } from '@40seas/models';
import { z } from 'zod';

export const BusinessContactSchema = z.object({
    id: z
        .string()
        .regex(/^[0-9a-f]{24}$/i)
        .optional(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    fullName: z.string().optional(),
    email: z
        .string({
            required_error: 'Please fill your email address',
        })
        .email(),
    address: AddressSchema.optional(),
    ssn: z.string().nullish(),
    phone: z.string().optional(),
    identification: IdentificationSchema.optional(),
    title: z.string().min(1).optional(),
    dateOfBirth: z.date().or(z.string()).optional(),
    isPrimary: z.boolean().default(false).optional(),
    isOwner: z.boolean().default(false).optional(),
    percentage: CastToNumber(z.number().min(0).max(100)).optional(),
    hasSignatureRights: z.boolean().default(false).optional(),
});

export class BusinessContact extends FromSchema(BusinessContactSchema) {
    id: string;
    firstName: string;
    lastName: string;
    fullName?: string;
    email: string;
    address?: Address;
    phone?: string;
    ssn?: string;
    identification?: Identification;
    title: string;
    dateOfBirth?: Date;
    isPrimary?: boolean = false;
    isOwner?: boolean = false;
    percentage?: number = 0;
    hasSignatureRights?: boolean = false;
}
